import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { ApiService, Carrello } from './api.service';
import { HeaderService } from './header.service';
import { StorageService } from './storage.service';
import * as i0 from "@angular/core";
import * as i1 from "./storage.service";
import * as i2 from "./api.service";
import * as i3 from "@ngx-translate/core";
import * as i4 from "./header.service";
var CarrelloService = /** @class */ (function () {
    function CarrelloService(storage, apiService, translate, header) {
        this.storage = storage;
        this.apiService = apiService;
        this.translate = translate;
        this.header = header;
    }
    CarrelloService.prototype.getCarrello = function () {
        if (this.storage.isBrowser) {
            var carrelloInSessione = this.storage.getLocal('carrello-stem');
            return carrelloInSessione ? of(carrelloInSessione) : this.aggiornaCarrello();
        }
        else {
            return of(new Carrello());
        }
    };
    CarrelloService.prototype.aggiornaCarrello = function () {
        var _this = this;
        var idCarrello = this.storage.getLocal('carrello-stem') ? this.storage.getLocal('carrello-stem').idCarrello : null;
        var language = this.translate.currentLang.toUpperCase();
        return this.apiService.getCarrello({ language: language, idCarrello: idCarrello }).pipe(map(function (_a) {
            var carrello = _a.carrello;
            if (!carrello.prodotti) {
                carrello.prodotti = [];
            }
            _this.storage.setLocal('carrello-stem', carrello);
            _this.header.aggiornaCarrello.emit();
            return carrello;
        }));
    };
    CarrelloService.prototype.salvaCarrello = function (carrello) {
        var _this = this;
        var language = this.translate.currentLang.toUpperCase();
        var utente = this.storage.getLocal('user-stem');
        if (utente) {
            carrello.idUtente = utente.idUtente;
        }
        return this.apiService.saveCarrello({ language: language, carrello: carrello }).pipe(map(function (res) {
            if (res.carrello && res.carrello.idCarrello) {
                if (!carrello.prodotti) {
                    carrello.prodotti = [];
                }
                _this.storage.setLocal('carrello-stem', res.carrello);
                _this.header.aggiornaCarrello.emit();
            }
            return res.carrello;
        }));
    };
    CarrelloService.prototype.salvaIndirizzo = function (indirizzo) {
        var _this = this;
        var language = this.translate.currentLang.toUpperCase();
        var utente = this.storage.getLocal('user-stem');
        if (utente) {
            indirizzo.idUtente = utente.idUtente;
        }
        return this.getCarrello().pipe(switchMap(function (_a) {
            var idCarrello = _a.idCarrello;
            indirizzo.idCarrello = idCarrello;
            return _this.apiService.saveIndirizzo({ language: language, indirizzo: indirizzo }).pipe(map(function (res) { return res.carrello; }));
        }));
    };
    CarrelloService.prototype.salvaProdotto = function (prodotto) {
        var _this = this;
        return this.getCarrello().pipe(switchMap(function (carrello) {
            var prodottoEsistente = carrello.prodotti.find(function (p) { return p.idScheda === prodotto.idScheda; });
            prodottoEsistente ?
                carrello.prodotti.splice(carrello.prodotti.indexOf(prodottoEsistente), 1, prodotto) :
                carrello.prodotti.push(prodotto);
            return _this.salvaCarrello(carrello);
        }));
    };
    CarrelloService.prototype.salvaProdotti = function (prodotti) {
        var _this = this;
        return this.getCarrello().pipe(switchMap(function (carrello) {
            prodotti.forEach(function (prodotto) {
                var prodottoEsistente = carrello.prodotti.find(function (p) { return p.idScheda === prodotto.idScheda; });
                prodottoEsistente ?
                    carrello.prodotti.splice(carrello.prodotti.indexOf(prodottoEsistente), 1, prodotto) :
                    carrello.prodotti.push(prodotto);
            });
            return _this.salvaCarrello(carrello);
        }));
    };
    CarrelloService.prototype.rimuoviProdotto = function (prodotto) {
        var _this = this;
        var language = this.translate.currentLang.toUpperCase();
        return this.getCarrello().pipe(switchMap(function (_a) {
            var idCarrello = _a.idCarrello;
            return _this.apiService.removeProdottoCarrello({ language: language, idScheda: prodotto.idScheda, idSchedaPadre: prodotto.idSchedaPadre, idPercorso: prodotto.idPercorso, idCarrello: idCarrello });
        }), map(function (_a) {
            var carrello = _a.carrello;
            if (!carrello.prodotti) {
                carrello.prodotti = [];
            }
            _this.storage.setLocal('carrello-stem', carrello);
            return carrello;
        }));
    };
    CarrelloService.prototype.getProdotto = function (idScheda) {
        return this.getCarrello().pipe(map(function (carrello) { return carrello.prodotti.find(function (p) { return idScheda === p.idScheda; }); }));
    };
    CarrelloService.prototype.getProdotti = function () {
        return this.getCarrello().pipe(map(function (carrello) { return carrello.prodotti || []; }));
    };
    CarrelloService.prototype.svuotaProdotti = function () {
        var _this = this;
        return this.getCarrello().pipe(switchMap(function (carrello) {
            carrello.prodotti = [];
            return _this.salvaCarrello(carrello);
        }));
    };
    CarrelloService.prototype.rimuoviCoupon = function () {
        var _this = this;
        return this.getCarrello().pipe(switchMap(function (carrello) {
            carrello.codiceCoupon = null;
            return _this.salvaCarrello(carrello);
        }));
    };
    /** @nocollapse */ CarrelloService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CarrelloService_Factory() { return new CarrelloService(i0.ɵɵinject(i1.StorageService), i0.ɵɵinject(i2.ApiService), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i4.HeaderService)); }, token: CarrelloService, providedIn: "root" });
    return CarrelloService;
}());
export { CarrelloService };
